var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"outlined":"","dense":"","label":"Nota","error-messages":_vm.errors},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})}
var staticRenderFns = []

export { render, staticRenderFns }